export const firebaseConfig = {
  apiKey: 'AIzaSyAqGzEvwU1RjFaFP3FEKs-SG3msaz7z254',
  authDomain: 'chance4talents-d54b5.firebaseapp.com',
  databaseURL: 'https://chance4talents-d54b5.firebaseio.com',
  projectId: 'chance4talents-d54b5',
  storageBucket: 'chance4talents-d54b5.appspot.com',
  messagingSenderId: '803836967180',
  appId: '1:803836967180:web:8d3cbdcc1199c9c6ebb129',
};

export const appURL = 'http://www.chance4talents.app/#';
export const cloudFunctions = 'https://us-central1-chance4talents-d54b5.cloudfunctions.net';
export const cloudFunctionsBackoffice = 'https://us-central1-backoffice-c4t.cloudfunctions.net';
export const webPushId = 'web.chance4talents.push';
// test
// export const stripePublicKey = 'pk_test_Rtg7JAvi1y1a45fOAaF4sYEv00AFtQljpb';
export const stripePublicKey = 'pk_live_BFETpqgmCKgHrjvUEvgdpqLL00300rGuJE';

export const paypalConfig = {
  clientId: '',
};

export const subscriptions = {
  scouts: [
    {
      id: 'price_1ILPeADRZSOKB8ce52KSXA7T', name: '3 Monate', price: '129,99€ *', value: 12999,
    },
    {
      id: 'price_1ILPdrDRZSOKB8cezpExTKHM', name: '12 Monate', price: '399€ *', value: 39900, mostSelected: true,
    },
    {
      id: 'price_1ILPe2DRZSOKB8ceKwEKKn8Z', name: '6 Monate', price: '224,99€ *', value: 22499,
    },
  ],
  teams: [
    // {
    //   id: 'price_1ILPeADRZSOKB8cevzXi7YZY', name: '3 Monate', price: '99,99€ *', value: 9999,
    // },
    // {
    //   id: 'price_1ILPdrDRZSOKB8ceDXbhNM8V', name: '12 Monate', price: '299€ *', value: 29900, mostSelected: true,
    // },
    // {
    //   id: 'price_1ILPe1DRZSOKB8ceOCmKPE9L', name: '6 Monate', price: '174,99€ *', value: 17499,
    // },
    {
      id: 'price_1K7dZwDRZSOKB8ce7CzRjjV9', name: 'einmalig', price: '149,00€ *', value: 14900, league: ['9', '10'], type: 'saison',
    },
    {
      id: 'price_1K7dZxDRZSOKB8cevro5I7kd', name: 'einmalig', price: '199,00€ *', value: 19900, league: ['8', '81'], type: 'saison',
    },
    {
      id: 'price_1K7dZxDRZSOKB8ceL4J6M8BC', name: 'einmalig', price: '299,00€ *', value: 29900, league: ['7', '71'], type: 'saison',
    },
    {
      id: 'price_1K7dZxDRZSOKB8ceqg5Z2E3H', name: 'einmalig', price: '499,00€ *', value: 49900, league: ['6', '61'], type: 'saison',
    },
    {
      id: 'price_1K7dZxDRZSOKB8ces8jGpEyP', name: 'einmalig', price: '799,00€ *', value: 79900, league: ['5'], type: 'saison',
    },
    {
      id: 'price_1K7dZxDRZSOKB8ceyFRYkSs0', name: 'einmalig', price: '1299,00€ *', value: 129900, league: ['4'], type: 'saison',
    },
  ],
};
export const paymentPackages = [
  {
    id: 1, name: '5 SWIPES', price: '2,49€', value: 249, swipes: 5,
  },
  {
    id: 2, name: '10 SWIPES', price: '3,99€', value: 399, swipes: 10,
  },
  {
    id: 3, name: '25 SWIPES', price: '9,99€', value: 999, swipes: 25,
  },
  {
    id: 4, name: '75 SWIPES', price: '24,99€', value: 2499, swipes: 75,
  },
  {
    id: 5, name: 'SWIPES unlimited', price: '99,99€ *', value: 9999, swipes: 9000000,
  },
];
export const paymentPackagesLeague = [
  {
    id: 'price_1K7dZwDRZSOKB8ce7CzRjjV9', name: 'einmalig', price: '149,00€ *', value: 14900, league: ['9', '10'], type: 'saison',
  },
  {
    id: 'price_1K7dZxDRZSOKB8cevro5I7kd', name: 'einmalig', price: '199,00€ *', value: 19900, league: ['8', '81'], type: 'saison',
  },
  {
    id: 'price_1K7dZxDRZSOKB8ceL4J6M8BC', name: 'einmalig', price: '299,00€ *', value: 29900, league: ['7', '71'], type: 'saison',
  },
  {
    id: 'price_1K7dZxDRZSOKB8ceqg5Z2E3H', name: 'einmalig', price: '499,00€ *', value: 49900, league: ['6', '61'], type: 'saison',
  },
  {
    id: 'price_1K7dZxDRZSOKB8ces8jGpEyP', name: 'einmalig', price: '799,00€ *', value: 79900, league: ['5'], type: 'saison',
  },
  {
    id: 'price_1K7dZxDRZSOKB8ceyFRYkSs0', name: 'einmalig', price: '1299,00€ *', value: 129900, league: ['4'], type: 'saison',
  },
];
